(() => {
 if (window.trufaCarouselInitialized) return;
 window.trufaCarouselInitialized = true;
 const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
 const init = () => document.querySelectorAll('[data-trufa-carousel]').forEach(root => {
  if (root.dataset.carouselReady) return;
  const track = root.querySelector('[data-carousel-track]');
  const controls = root.querySelector('[data-carousel-controls]');
  if (!track || !controls || track.children.length < 2) return;
  root.dataset.carouselReady = 'true'; controls.hidden = false;
  const prev = controls.querySelector('[data-carousel-prev]');
  const next = controls.querySelector('[data-carousel-next]');
  const update = () => { prev.disabled = track.scrollLeft < 4; next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4; };
  const move = direction => { const first = track.firstElementChild; track.scrollBy({left:direction * (first.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0)), behavior:reduced.matches ? 'auto' : 'smooth'}); };
  prev.addEventListener('click',()=>move(-1)); next.addEventListener('click',()=>move(1));
  track.addEventListener('keydown',event=>{ if(event.target !== track)return; if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();move(event.key==='ArrowRight'?1:-1);} });
  track.addEventListener('scroll',update,{passive:true});
  if ('ResizeObserver' in window) new ResizeObserver(update).observe(track);
  update();
 });
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
 document.addEventListener('shopify:section:load',init);
})();
